<template>
    <div v-if="bellInfo != null">
        <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.item_bell_info')" name="bellInfo"></el-tab-pane>
            <el-tab-pane :label="$t('message.item_bell_auth_user')" name="authUser"></el-tab-pane>
            <!--  Add the tab of targetGroup when multi target groups is supported -->

            <template v-if="selectedTabName==='bellInfo'">
                <div class="object-titlebox">
                    <div class="object-titlebox-right">
                        <button class="transparent-button" type="button" v-on:click="showDialog('delete')"><img src="../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('qr')"><img src="../assets/qr.svg"/><span class="normal-command-text" v-t="'message.action_show_qr'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('duplicate')"><img src="../assets/copy.svg"/><span class="normal-command-text" v-t="'message.action_duplicate'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('edit')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                    </div>
                </div>
                <table width=100%>
                    <tr class="objectitem-record"><td class="object-item" width=50% v-t="'message.item_bell_id'"></td><td class="object-value">{{ bellInfo.name }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_display_name'"></td><td class="object-value">{{ bellInfo.displayName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_target_group'"></td><td class="object-value">{{ displayTargetGroupNames }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_notify_lang'"></td><td class="object-value">{{ displayNotifyLang }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_notify_items'"></td><td class="object-value">{{ displayNotifyItems }}</td></tr>
                    <tr class="objectitem-record">
                        <td class="object-item">
                            <div v-t="'message.item_bell_usage_time'"/>
                            <div style="font-size:10px; font-weight:bold; color:#67b853" v-html="$t('message.info_bell_usage_time_hint')"></div>
                        </td>
                        <td v-if="enableUsageTime" class="object-value">
                            <div>
                                {{ displayUsageTime }}
                            </div>
                        </td>
                        <td v-else class="object-value">
                            <span v-t="'message.item_value_notSet'"/>
                        </td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item">
                            <div v-t="'message.item_bell_usage_point'"/>
                            <div style="font-size:10px; font-weight:bold; color:#67b853" v-html="$t('message.info_bell_usage_point_hint')"></div>
                        </td>
                        <td v-if="enabledUsagePoint" class="object-value">
                            <span v-t="'message.item_value_inSet'"/>
                            <div>
                                <button class="transparent-button" type="button" @click="showUsagePointBell()">
                                    <i class="el-icon-location-information"/>
                                    <span class="normal-command-text" style="margin-left:5px" v-t="'message.item_bell_check_usage_point'"/>
                                </button>
                            </div>
                        </td>
                        <td v-else class="object-value">
                            <span v-t="'message.item_value_notSet'"/>
                        </td>
                    </tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_created_time'"></td><td class="object-value">{{ displayCreatedTime }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_updated_time'"></td><td class="object-value">{{ displayUpdatedTime }}</td></tr>
                </table>
                <div class="object-titlebox">
                    <div class="object-titlebox-left">
                        <span>{{ $t('message.item_bell_display_setting') }}</span>
                    </div>
                    <div class="object-titlebox-right">
                        <button class="transparent-button" type="button" v-on:click="showDialog('editSettings')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                    </div>
                </div>
                <div v-if="existsSettings">
                    <table width=100%>
                        <tr class="objectitem-record"><td class="object-item" width=50% v-t="'message.item_bell_display_languages'"></td><td class="object-value">{{ displayLanguages }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_display_page_contents'"></td>
                            <td class="object-value">
                                <div>
                                    <button class="transparent-button" type="button" @click="previewBell()"><i class="el-icon-full-screen"></i><span class="normal-command-text" style="margin-left:5px" v-t="'message.action_preview'"></span></button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div v-else class="default-message" style="margin-top: 30px" v-html="$t('message.info_message_unset')"/>
            </template>

            <template v-else-if="selectedTabName==='authUser'">
                <div class="default-message" style="padding: 30px">
                    <br>
                    <span v-html="$t('message.info_bell_auth_guide1')"></span>
                    <br><br>
                    <span>
                        <a :href="bellDashboardUrl" target="_blank">{{ bellDashboardUrl }}</a>
                    </span>
                    <br><br>
                </div>
                <div class="object-titlebox">
                    <div class="object-titlebox-left" v-t="{ path: 'message.title_bell_auth_user', args: { name: bellInfo.name, userCount: authUserList.length} }"></div>
                    <div class="object-titlebox-right">
                        <div v-if="authUserList.length === 0">
                            <button class="transparent-button" type="button" v-on:click="showDialog('editAuth')"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_user'"></span></button>
                        </div>
                        <div v-else>
                            <button class="transparent-button" type="button" v-on:click="showDialog('editAuth')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_user'"></span></button>
                        </div>
                    </div>
                </div>
                <table width=100%>
                    <tr class="authorized-user-title">
                        <td class="authorized-user-header1" v-t="'message.item_userId_displayName'"></td>
                        <td class="authorized-user-header2" v-t="'message.common_action_delete'"></td>
                    </tr>
                    <tr class="authorized-user-record" v-for="(user, _) in authUserList">
                        <td class="object-item">{{ authUserDescription(user) }}</td>
                        <td class="object-item2">
                            <button class="item-record-button" type="button" v-on:click="confirmDeleteBellAuth(user)"><img class="icon-delete" src="../assets/icon_delete_user.svg"/></button>
                        </td>
                    </tr>
                </table>
                <div v-if="authUserList.length === 0" class="default-message" style="margin-top: 30px" v-html="$t('message.info_message_unset')"/>
            </template>

        </el-tabs>

        <!-- bellInfo tab -->
        <QrBell v-if="showQrBell" :bellInfo="{tenantId: tenantId, id: bellInfo.id, name: bellInfo.name}" :bellClientUrl="bellClientUrl" @back="showQrBell=false"></QrBell>
        <EditBell v-if="showEditBell" :appData="appData" :bellInfo="bellInfo" @update="updateBell" @cancel="showEditBell=false"></EditBell>
        <EditBellSettings v-if="showEditBellSettings" :appData="appData" :bellInfo="bellInfo" @update="updateBell" @cancel="showEditBellSettings=false"></EditBellSettings>
        <DeleteBell v-if="showDeleteBell" :confirmInfo="confirmInfo" @delete="deleteBell" @cancel="showDeleteBell=false"></DeleteBell>
        <DuplicateBell v-if="showDuplicateBell" :appData="appData" :bellInfo="bellInfo" @save="duplicateBell" @cancel="showDuplicateBell=false"></DuplicateBell>
        <!-- authUser tab -->
        <EditBellAuth v-if="showEditBellAuth" :appData="appData" :authUsers="authUserListForUserSelection()" @update="editBellAuth" @cancel="showEditBellAuth=false"></EditBellAuth>
        <DeleteBellAuth v-if="showDeleteBellAuth" :confirmInfo="userConfirmInfo" @delete="deleteBellAuth" @cancel="showDeleteBellAuth=false"></DeleteBellAuth>
    </div>
</template>

<script>
import server from "./ServerApi.js";
import QrBell from "./BellQr.vue";
import EditBell from "./BellEdit.vue";
import EditBellSettings from "./BellEditDisplaySettings.vue"
import DeleteBell from "./BellDelete.vue";
import DuplicateBell from "./BellDuplicate.vue";
import EditBellAuth from "./BellAuthEdit.vue";
import DeleteBellAuth from "./BellAuthDelete.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    components: {
        QrBell,
        EditBell,
        EditBellSettings,
        DeleteBell,
        DuplicateBell,
        EditBellAuth,
        DeleteBellAuth,
    },

    props: {
        selectedNode: Object,
        appData: Object,
        bellDashboardUrl: String,
        bellClientUrl: String,
    },

    data() {
        return {
            tenantId: null,
            bellInfo: null,
            showTab: true,
            selectedTabName: null,
            loadingScreen: null,
            isAdminUser: false,

            // bellInfo tab
            languageList: [],
            notificationItems: [],
            showQrBell: false,
            showEditBell: false,
            showEditBellSettings: false,
            showDeleteBell: false,
            showDuplicateBell: false,
            showPreviewBell: false,
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },

            // authUser tab
            authUserList: [],
            showEditBellAuth: false,
            showDeleteBellAuth: false,
            userConfirmInfo: {
                user: null,
            },
        };
    },

    computed: {
        existsSettings() {
            return this.bellInfo != null
                && this.bellInfo.settings != null
                && this.bellInfo.settings.context
                && Object.keys(this.bellInfo.settings.context).length !== 0;
        },
        displayLanguages() {
            if (!this.existsSettings) {
                return "";
            }
            return this.languageList
                .filter(lang => this.bellInfo.settings.context[lang.languageCode])
                .map(lang => this.languageDescription(lang))
                .join(' / ')
        },
        displayTargetGroupNames() {
            return this.bellInfo.groups
                .map(g => g.talkgroupName)
                .join(" / ")
        },
        displayNotifyLang() {
            let language = this.languageList.find(lang => lang.value === this.bellInfo.notifyLang)
            return this.languageDescription(language);
        },
        displayNotifyItems() {
            return this.notificationItems
                .filter(item => this.bellInfo.notifyItems.includes(item.name))
                .map(item => this.notificationItemDescription(item))
                .join(' / ')
        },
        displayUsageTime() {
            if (this.enableUsageTime) {
                // Human-friendly notation
                let localStart, localEnd;
                let offset = -(new Date().getTimezoneOffset());
                localStart = this.calculateMinutes(this.bellInfo.usageTime.start, offset);
                localEnd   = this.calculateMinutes(this.bellInfo.usageTime.end, offset);
                if (localStart === '24:00') {
                    localStart = '00:00';
                }
                if (localEnd === '00:00') {
                    localEnd = '24:00';
                }
                return `${localStart} - ${localEnd}`;
            } else {
                return commonUtil.getMessageText(this.$i18n, "item_value_notSet")
            }
        },
        displayCreatedTime() {
            return new Date(this.bellInfo.createdTime).toLocaleString();
        },
        displayUpdatedTime() {
            return new Date(this.bellInfo.updatedTime).toLocaleString();
        },
        enableUsageTime() {
            return this.bellInfo.usageTime.start && this.bellInfo.usageTime.end && (this.bellInfo.usageTime.start !== this.bellInfo.usageTime.end);
        },
        enabledUsagePoint() {
            return this.bellInfo.usagePoint.latitude && this.bellInfo.usagePoint.longitude;
        }
    },

    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                this.getBellDetail();
            }
        },
        'appData.onlinePurchase'(newVal) {
            this.getBellDetail();
        }
    },

    created() {
        this.tenantId = this.appData.tenantList[0].tenantId;
        this.languageList = commonUtil.getLanguageIndexList()
        this.notificationItems = commonUtil.getBellNotificationItems();
        this.selectedTabName = "bellInfo";
        this.getBellDetail();
    },

    methods: {
        languageDescription(language) {
            if (this.$i18n.locale === 'ja') {
                return language.description;
            } else {
                return language.description_en
            }
        },
        notificationItemDescription(item) {
            if (this.$i18n.locale === 'ja') {
                return item.description;
            } else {
                return item.description_en
            }
        },
        authUserDescription(user) {
            return user.userName + "@" +  this.appData.tenantList[0].name + " / " + user.displayName;
        },
        authUserListForUserSelection() {
            return this.authUserList.map(user => {
                return {
                    tenantId: this.tenantId,
                    id: user.userId,
                    pid: 0,
                    name: user.userName,
                    displayName: user.displayName,
                    restrictions: user.restrictions,
                    rights: user.rights,
                    publishInformations: user.publishInformations,
                    optionFlag: user.optionFlag,
                }
            });
        },
        calculateMinutes(time, minutes) {
            const parts = time.split(':');
            const date = new Date();
            date.setHours(parts[0]);
            date.setMinutes(parts[1]);

            date.setMinutes(date.getMinutes() + minutes);

            const hours = date.getHours().toString().padStart(2, '0');
            const mins = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${mins}`;
        },
        async getBellDetail() {
            if (this.selectedNode == null) {
                return;
            }

            this.showLoadingScreen();
            try {
                const res = await server.post('/getbell', {id: this.selectedNode.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        console.log(res.data.status)
                        this.bellInfo = res.data.data;
                        this.getBellAuthUsers();
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_not_found"));
                        this.$emit('refresh', true);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getBellDetail").replace("{code}", res.data.status));
                        break;
                }
                this.closeLoadingScreen();

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getBellDetail", e);
                this.closeLoadingScreen();
            }
        },
        async getBellAuthUsers() {
            try {
                const res = await server.post('/getbellauthuser', {id: this.bellInfo.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        res.data.users.sort((u1, u2) => {
                            return commonUtil.compareStringWithNumber(u1.userName, u2.userName);
                        });
                        this.authUserList = res.data.users;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getBellAuthUsers").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getBellAuthUsers", e);
            }
        },
        async updateBell(payload) {
            try {
                const res = await server.post("/updatebell", payload);
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_edit_success"));
                        this.showEditBell = false;
                        this.showEditBellSettings = false;
                        if (payload.name) {
                            // In case of invoked from BellEdit, not BellDisplaySettings
                            this.selectedNode.name = payload.name
                        }
                        this.getBellDetail();
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_error_exists_same_name"));
                        break;
                    case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_count"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_size"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "updateBell").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getInfo", e);
            }
        },
        async deleteBell() {
            try {
                const res = await server.post("/deletebell", {id: this.bellInfo.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "item_bell_delete_success"));
                        this.showDeleteBell = false;
                        this.$emit('refresh', true);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deleteBell").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "deleteBell", e);
            }
        },
        async duplicateBell(originalBellInfo, newBellName) {
            try {
                const res = await server.post("/duplicatebell", {originalId: originalBellInfo.id, name: newBellName})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "item_bell_duplicated_success"));
                        this.showDuplicateBell = false;
                        this.$emit('refresh');
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_error_exists_same_name"));
                        break;
                    case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_count"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "duplicateBell").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "duplicateBell", e);
            }
        },
        async deleteBellAuth() {
            this.showDeleteBellAuth = false;

            try {
                const res = await server.post("/editbellauthuser", {id: this.bellInfo.id, addUserIdList: [], deleteUserIdList: [this.userConfirmInfo.user.userId]})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_auth_deleted"));
                        this.getBellAuthUsers();
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deleteBellAuth").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "editBellAuth", e);
            }
        },
        async editBellAuth(removeTagList, addTagList) {
            this.showEditBellAuth = false;

            let addUserIdList = [];
            let deleteUserIdList = [];

            if (addTagList) {
                for (let key in addTagList) {
                    addUserIdList.push(addTagList[key].userId);
                }
            }

            if (removeTagList) {
                for (let key in removeTagList) {
                    deleteUserIdList.push(removeTagList[key].userId);
                }
            }

            if (addUserIdList.length === 0 && deleteUserIdList.length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                return;
            }

            if (this.authUserList.length + addUserIdList.length - deleteUserIdList.length > constants.BELL_MAX_AUTH_USER_LIMIT) {
                commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_bell_max_auth_user_count").replace("{limit}", constants.BELL_MAX_AUTH_USER_LIMIT));
                return;
            }

            try {
                const res = await server.post("/editbellauthuser", {id: this.bellInfo.id, addUserIdList: addUserIdList, deleteUserIdList: deleteUserIdList})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_auth_edited"));
                        this.getBellAuthUsers();
                        break;
                    case constants.STATUS_ERROR_BELL_AUTH_USER_LIMIT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_auth_max_count")
                            .replace("{user_limit}", constants.BELL_MAX_AUTH_USER_LIMIT)
                            .replace("{bell_limit}", constants.BELL_MAX_AUTHED_BELL_LIMIT));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "editBellAuth").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "editBellAuth", e);
            }
        },
        previewBell() {
            let url = `${this.bellClientUrl}?preview=true`;

            let width = 400;
            let height = 700;
            let left = (window.screen.width / 2) - (width / 2);
            let top = (window.screen.height / 2) - (height / 2);

            const popup = window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
            if (popup !== null) {
                // a little wait pre postMessage
                setTimeout(() => popup.postMessage(
                    {displayName: this.bellInfo.displayName, settings: this.bellInfo.settings},
                    this.bellClientUrl
                ), 500);
            }
        },
        showUsagePointBell() {
            let latitude = this.bellInfo.usagePoint.latitude;
            let longitude = this.bellInfo.usagePoint.longitude;
            let url = `https://www.google.com/maps?q=${latitude},${longitude}`
            // &hl=${your_language}&region=${your_region}&z=15`;
            window.open(url, '_blank',"noopener,noreferrer");
        },
        confirmDeleteBellAuth(user) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.userConfirmInfo.user = user;
            this.showDeleteBellAuth = true;
        },
        showDialog(functionName) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }

            switch (functionName) {
                case "edit":
                    this.showEditBell = true;
                    break;
                case "editSettings":
                    this.showEditBellSettings = true;
                    break;
                case "duplicate":
                    this.showDuplicateBell = true;
                    break;
                case "delete":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "item_bell");
                    this.confirmInfo.objectName = this.bellInfo.name;
                    this.showDeleteBell = true;
                    break;
                case "qr":
                    if (!this.existsSettings) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_qr_need_display_settings"));
                        break;
                    }
                    this.showQrBell = true;
                    break;
                case "editAuth":
                    this.showEditBellAuth = true;
                    break;
                default:
                    break;
            }
        },
        handleChangeTab() {
            if (this.selectedTabName === "authUser") {
                this.getBellAuthUsers();
            }
            this.reDrawTab();
        },
        beforeLeave(activeName, oldActiveName) {
            return true;
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                        lock: true ,
                        text: 'Loading data ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                 this.showTab = true
            })
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  list-style:none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
  float: right;
}

input[type="radio"]{
    outline: 0;
     -webkit-appearance: none;
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../assets/icon_check_gray.svg);
}
input[type="radio"]:checked {
    outline: 0;
    width: 20px;
    height: 20px;
    background: url(../assets/icon_check_green.svg);
}
input[type="radio"]:hover {
     cursor : pointer;
}
.authorized-user-record {
    border-bottom:1px #eee solid;
}
.authorized-user-record:hover {
    background-color: #ecf1fa;
}
.authorized-user-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.authorized-user-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.authorized-user-header2 {
    width: 15%;
    text-align:center;
}
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.custom-checkbox-input {
  display: none;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}
</style>
